import { createConfirmation } from 'react-confirm'
import ConfirmDialogIkeaCenter from './ConfirmDialogIkeaCenter'

// create confirm function
const confirm = createConfirmation(ConfirmDialogIkeaCenter)

export default function(confirmation, strEmployeeId, options = {}) {
    return confirm({ confirmation, strEmployeeId, options })
}
